module.exports = __webpack_public_path__ + "static/media/PatientBannerPlain-v1.1.8485616e.png";